export const toCurrency = (value: number, fractionDigitis = 2) =>
  value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: fractionDigitis,
    maximumFractionDigits: fractionDigitis,
  })
